import { Routes } from "@angular/router";
import { AuthLayout } from "./core/layouts/auth-layout/auth-layout";
import { MainLayout } from "./core/layouts/main-layout/main-layout";
import { NotFound } from "./features/not-found/not-found";
import { isAuthenticated } from "./core/guards/auth.guard";

export const routes: Routes = [
    {
        path: "",
        component: MainLayout,
        canMatch: [isAuthenticated],
        loadChildren: () => import("./core/layouts/main-layout/main-layout.routes").then((m) => m.MAIN_ROUTES),
    },
    {
        path: "",
        component: AuthLayout,
        loadChildren: () => import("./core/layouts/auth-layout/auth-layout.routes").then((m) => m.AUTH_ROUTES),
    },
    {
        path: "**",
        component: NotFound,
    },
];
